import type { PollsGateway } from '../ports/pollsGateway';

import { fetchClient } from '@/util/fetchClient';

/**
 * Polls' backend, over the generated API client. The wire shapes are
 * assignable to the model's, so both reads pass the response through as is,
 * and the caches hold exactly what they held before the gateway existed.
 */
export const fetchPollsGateway: PollsGateway = {
  async listMyPollResponses() {
    const { data } = await fetchClient.GET('/v2/surveys/responses/me', {
      params: { query: { surveyType: 'poll' } },
    });

    return data?.data ?? [];
  },

  /**
   * Any confirmed account may read a poll's results, so callers need no
   * `resultsUrl` to ask. Calling the typed route keeps the response typed where a
   * raw string would not.
   */
  async getSurveyResults(surveyGroupId) {
    const { data } = await fetchClient.GET('/v2/surveys/{groupIdOrSlug}/results', {
      params: { path: { groupIdOrSlug: surveyGroupId } },
    });

    return data?.data;
  },
};
